import { Link } from 'react-router-dom';
import { aboutTrustBadges } from '@/mocks/aboutData';
import { useTranslation } from 'react-i18next';

const trustBadgeIcons = aboutTrustBadges.map((b) => b.icon);

export default function HeroSection() {
  const { t } = useTranslation();
  const badges = [
    { icon: trustBadgeIcons[0], text: t('about.hero.badge1') },
    { icon: trustBadgeIcons[1], text: t('about.hero.badge2') },
    { icon: trustBadgeIcons[2], text: t('about.hero.badge3') },
  ];
  return (
    <>
    <section className="hero-billboard relative w-full h-[60vh] min-h-[460px] md:h-[82vh] md:min-h-[640px] overflow-hidden">
      <img
        src="/images/generated/about-hero-2026.jpg"
        alt={t('about.hero.imgAlt')}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 hero-overlay"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="relative w-full px-8">
          <div className="max-w-[800px] mx-auto text-center">
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-50 tracking-[0.08em] mb-4">
              {t('about.hero.title')}
            </h1>
            {String(t('about.hero.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] md:text-[17px] tracking-[0.12em] mb-6">{__s}</p>))}
            {String(t('about.hero.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-200/80 tracking-[0.05em] leading-relaxed max-w-[720px] mx-auto mb-10">{__s}</p>))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-primary-900/70 backdrop-blur-sm">
        <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-5 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          {badges.map((badge, idx) => (
            <div key={idx} className="flex items-center gap-3 text-foreground-200">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${badge.icon} text-accent-400 text-sm`}></i>
              </div>
              <span className="text-[14px] tracking-[0.05em] whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
    <nav aria-label="パンくずリスト" className="bg-background-50 border-b border-background-200"><div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-3 flex items-center gap-2 text-[13px] text-foreground-500"><Link to="/" className="hover:text-accent-600 transition-colors">{t('about.hero.homeLink')}</Link><i className="ri-arrow-right-s-line text-foreground-400 text-[12px]"></i><span className="text-foreground-700">{t('about.hero.currentPage')}</span></div></nav>
    </>
  );
}